import React from 'react';
import LastCheckDeliverabilityHint from './LastCheckDeliverabilityHint.jsx';
import {Typography} from '@bonprix/design-system';

export default function LastCheckCartTop({cart, isDeliveryToPickUpLocationNotPossible, texts}) {
    return (
        <div className="flex justify-between items-center flex-wrap w-full l:mt-14">
            <Typography variant="h3" component="h2">{texts.cot_lastcheck_cart_heading}</Typography>
            <Typography component="span">({cart.summary.itemCount} {texts.wishlist_artikel})</Typography>
            <div className="last-check__cart-head__seperator mt-2.5" />
            <LastCheckDeliverabilityHint
                items={cart.items}
                texts={texts}
                isDeliveryToPickUpLocationNotPossible={isDeliveryToPickUpLocationNotPossible}
            />
        </div>
    );
}
